var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 19.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,9.63A10,10,0,0,1,13.37,20h0a.5.5,0,0,1,0-1,9,9,0,0,0,5.8-15.58A9,9,0,0,0,6.35,4,9.77,9.77,0,0,0,4,10.19l2.64-3a.5.5,0,0,1,.76.66l-3.48,4a.45.45,0,0,1-.19.14h0l-.13,0H3.47l-.06,0L3.3,12l-.09,0-.07-.07-.06-.05-3-4.5a.51.51,0,0,1,.14-.7.51.51,0,0,1,.7.14L3,9.85A10.59,10.59,0,0,1,5.61,3.29a9.78,9.78,0,0,1,7-3.28A10,10,0,0,1,23,9.63Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReActivate);
export default __webpack_public_path__ + "static/media/re-activate.fe8c02a4fc55b907781109e40961e341.svg";
export { ForwardRef as ReactComponent };